import router from "@/router";
import { defineStore } from "pinia";

const actions = {
  async goHome() {
    if (router.currentRoute.name != "Home") {
      await router.push(this.defaultHomeRoute());
    }
  },
  async goListHome(list = "politicians") {
    await router.push(this.defaultHomeRoute(list));
  },
  openFilters() {
    this.showFilters = true;
  },
  triggerSearch() {
    this.searchTrigger++;
  },
};

export const useMainStore = defineStore("main", {
  state: () => ({
    state: null,
    lists: [
      {
        viewName: "ListPoliticians",
        plural_key: "politicians",
        plural_icon: "mdi-account-multiple",
      },
      {
        viewName: "ListAccounts",
        plural_key: "accounts",
        plural_icon: "mdi-office-building",
      },
      {
        viewName: "ListProjects",
        plural_key: "projects",
        plural_icon: "mdi-file-document-multiple",
      },
      {
        viewName: "ListVotings",
        plural_key: "votings",
        plural_icon: "mdi-archive",
      },
      {
        viewName: "ListPublications",
        plural_key: "publications",
        plural_icon: "mdi-newspaper-variant-multiple",
      },
    ],
    offLine: false, // TODO: window && !window.navigator?.onLine,
    appVersion: import.meta.env.VITE_APP_VERSION,
    goingBack: false,
    globalSearch: "",
    printView: false,
    showFilters: false,
    searchTrigger: 0,
  }),
  getters: {
    defaultHomeRoute() {
      return (list = "politicians") => ({
        name: "Home",
        params: { list },
        query: { filters: "{}" },
      });
    },
    isOffline: (state) => state.offLine,
  },
  actions,
});
